<template>
  <div>
    <Modal
      v-model="selectModal"
      title="选择网络设备"
      width="1000">
      <div style="text-align: left">
        <RadioGroup v-model="selectType">
          <Radio label="server">常规选择</Radio>
          <Radio label="group">从分组选择</Radio>
        </RadioGroup>
      </div>
      <ul v-show="selectType === 'group'" :id="groupZTreeID" class="ztree"></ul>
      <Divider />
      <div>
        <span>已选网络设备(<b>{{ selectRow.length }}</b>)：<a v-on:click="emptySelect" v-if="selectRow.length">清空 </a> </span>
        <Tag color="primary" closable v-for="(item, index) in selectRow" :key="'name_' + index" @on-close="removeSelect('remove', item)">{{ item }}</Tag>
      </div>
      <Divider />
      <Form inline :label-width="50" ref="searchSelectForm" :model="searchSelectForm">
        <FormItem label="设备名">
          <Input v-model="searchSelectForm.name" @on-enter="getData()" placeholder="过滤设备名"/>
        </FormItem>
        <FormItem label="设备类型" :label-width="60">
          <Select v-model="searchSelectForm.asset_type" style="min-width:200px" clearable>
            <Option v-for="item in assetTypeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="设备管理IP" :label-width="80">
          <Input v-model="searchSelectForm.asset_ip" @on-enter="getData()" placeholder="过滤设备管理IP"/>
        </FormItem>
        <FormItem :label-width="0" class="mob-align-right">
          <Button type="primary" @click="getData()" style="margin-right: 8px">搜索</Button>
          <Button @click="resetSelectSearchForm">重置</Button>
        </FormItem>
      </Form>
      <Alert v-if="serverError" type="warning" show-icon>获取网络设备列表失败</Alert>
      <div v-else>
        <Alert show-icon>提示！无法选择未填写设备名称的设备！</Alert>
        <Table
          ref="serverTable"
          :loading="dataTableLoading"
          :data="tableData.data"
          size="small"
          :columns="tableData.columns">
        </Table>
        <div style="margin: 10px 0; overflow: hidden;">
          <div style="float: left;">
            当前显示 {{ tableData.data.length }} 条记录，总共 {{ tableData.count }} 条记录
          </div>
          <div style="float: right;">
            <page :total="tableData.count" :current="tableData.page" :page-size="tableData.size" @on-change="getData"></page>
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" style="margin-right: 8px" @click="selectOk">确定</Button>
        <Button @click="selectModal = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getNetworkServer, getNetworkServerGroup, getNetworkAllServer } from '@/api/network'
import { iRandom } from '@/libs/tools'
export default {
  name: 'select-network-asset',
  data () {
    return {
      // 选择目标服务器
      serverError: false,
      selectModal: false,
      selected: [],
      selectType: 'server',
      searchSelectForm: {
        name: '',
        asset_type: '',
        asset_ip: ''
      },
      assetParams: {},
      tableData: {
        data: [],
        columns: [
          {
            title: '选中',
            align: 'center',
            minWidth: 60,
            key: 'checkBox',
            render: (h, params) => {
              let disabled = false
              if (!params.row.name) {
                disabled = true
              }
              let isCheck = false
              if (this.selectRow.indexOf(params.row.name) > -1) {
                isCheck = true
              }
              return h('div', [
                h('Checkbox', {
                  props: {
                    value: isCheck,
                    disabled: disabled
                  },
                  on: {
                    'on-change': (e) => {
                      this.tableData.data[params.index].checkBox = e
                      if (e) {
                        if (this.selectRow.indexOf(params.row.name) < 0) {
                          this.selectRow.push(params.row.name)
                          this.selectIds[params.row.name] = params.row.id
                        }
                      } else {
                        this.removeSelect(null, params.row.name)
                      }
                    }
                  }
                })
              ])
            }
          },
          {
            minWidth: 160,
            title: '设备名称',
            tooltip: true,
            align: 'center',
            key: 'name',
            render: (h, params) => {
              if (params.row.name) {
                return h('div', params.row.name)
              } else {
                return h('div', '未填设备名称,不能选择')
              }
            }
          },
          {
            minWidth: 130,
            title: '设备类型',
            align: 'center',
            key: 'asset_type',
            render: (h, params) => {
              let k = { 0: '软件', 1: '硬件', 2: '交换设备', 3: '路由设备', 4: '安全设备', 9: '未知' }
              return h('div', k[params.row.asset_type])
            }
          },
          {
            minWidth: 130,
            title: '设备管理地址',
            align: 'center',
            key: 'asset_ip'
          },
          {
            minWidth: 180,
            title: '正常运行时长',
            align: 'center',
            key: 'run_time'
          }
        ],
        count: 0,
        page: 1,
        size: 5
      },
      dataTableLoading: false,
      selectRow: [],
      selectIds: {},
      endSelect: {},
      endSelectLength: 0,
      id: '',
      assetTypeList: [
        {
          value: 0,
          label: '软件'
        },
        {
          value: 1,
          label: '硬件'
        },
        {
          value: 2,
          label: '交换设备'
        },
        {
          value: 3,
          label: '路由设备'
        },
        {
          value: 4,
          label: '安全设备'
        },
        {
          value: 9,
          label: '未知'
        }
      ],
      // 设备组
      zTreeSetting: {
        view: {
          selectedMulti: false
        },
        data: {
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'parent_id',
            rootPId: 0
          }
        },
        check: {
          enable: false
        },
        callback: {
          onClick: this.zTreeOnClick,
          onRightClick: this.OnRightClick
        }
      },
      zTree: '',
      zNodes: [{ 'id': 0, 'parent_id': 0, 'name': '所有设备', 'open': 'true' }],
      groupZTreeID: 'groupZTreeID_' + iRandom()
    }
  },
  methods: {
    // 打开服务器选择Modal
    openSelectNetworkAssetModal (assetParams = {}, selected = {}, id = '') {
      this.id = id
      this.assetParams = assetParams
      this.selectModal = true
      this.getData()
      this.getServerGroup()
      this.selectIds = {}
      this.selectRow = []
      for (let name in selected) {
        if (selected[name]) {
          this.selectRow.push(name)
          this.selectIds[name] = selected[name]
        }
      }
    },
    // 获取服务器分组列表
    getServerGroup () {
      this.zNodes = [{ 'id': 0, 'parent_id': 0, 'name': '所有设备', 'open': 'true' }]
      getNetworkServerGroup().then(res => {
        this.zNodes = this.zNodes.concat(res.data)
        this.zTreeInit()
      }).catch(res => {
        if (res.request) {
          that.$Notice.error({
            title: '获取网络设备分组失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    // zTree初始化
    zTreeInit () {
      this.zTree = $.fn.zTree.init($('#' + this.groupZTreeID), this.zTreeSetting, this.zNodes)
    },
    // 点击网络设备列表
    zTreeOnClick (event, treeId, treeNode) {
      let idIn = ''
      if (treeNode.id !== 0) {
        let childNodes = this.getChildNodes(treeNode)
        if (childNodes) {
          idIn = childNodes
        } else {
          idIn = 99999999
        }
      }
      this.emptySelect()
      getNetworkAllServer({ id__in: idIn }).then(res => {
        let result = res.data
        for (let i in result) {
          if (result[i].name) {
            this.selectRow.push(result[i].name)
            this.selectIds[result[i].name] = result[i].id
          }
        }
        this.getData(this.tableData.page)
      })
    },
    // 获取子Nodes
    getChildNodes (treeNode) {
      let childNodes = this.zTree.transformToArray(treeNode)
      let nodes = []
      for (let i = 0; i < childNodes.length; i++) {
        if (childNodes[i].server) {
          nodes = nodes.concat(childNodes[i].server.split(','))
        }
      }
      return nodes.join(',')
    },
    // 获取网络设备列表
    getData (value = 1) {
      this.tableData.page = value
      this.dataTableLoading = true
      this.searchSelectForm['size'] = this.tableData.size
      this.searchSelectForm['page'] = this.tableData.page
      for (let p in this.assetParams) {
        this.searchSelectForm[p] = this.assetParams[p]
      }
      this.serverError = false
      getNetworkServer(this.searchSelectForm).then(res => {
        let result = res.data
        this.tableData.count = result.count
        this.tableData.data = result.results
        this.dataTableLoading = false
      }).catch(res => {
        this.serverError = true
        this.dataTableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取网络设备列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    // 重置搜索表单
    resetSelectSearchForm () {
      this.searchSelectForm = {
        name: '',
        asset_type: '',
        asset_ip: ''
      }
      this.getData()
    },
    // 移除选中的服务器
    removeSelect (event, name) {
      if (event) {
        for (let i in this.tableData.data) {
          if (this.tableData.data[i].name === name) {
            this.tableData.data[i].checkBox = false
            break
          }
        }
      }
      const index = this.selectRow.indexOf(name)
      this.selectRow.splice(index, 1)
      this.selectIds[name] = null
    },
    // 清空选中的服务器
    emptySelect () {
      this.selectIds = {}
      for (let i in this.tableData.data) {
        this.tableData.data[i].checkBox = false
      }
      this.selectRow = []
    },
    // 选择服务器完成
    selectOk () {
      this.endSelect = {}
      for (let name in this.selectIds) {
        if (this.selectIds[name]) {
          this.endSelect[name] = this.selectIds[name]
        }
      }
      this.selectIds = {}
      this.selectRow = []
      this.endSelectLength = Object.keys(this.endSelect).length
      this.selectModal = false
      this.$emit('selectNetworkAssetComplete', this.endSelect, this.endSelectLength, this.id)
    }
  }
}
</script>

<style>
  @import '../../../plugin/ztree/css/metroStyle/metroStyle.css';
  #rMenu {
    position:absolute;
    visibility:hidden;
    top:0;
    background-color: #555;
    text-align: left;
    padding: 2px;
  }
  #rMenu a{
    padding: 3px 15px 3px 15px;
    cursor: pointer;
    list-style: none outside none;
  }
  .list-group-item {
    position: relative;
    display: block;
    padding: 10px 15px;
    margin-bottom: -1px;
    background-color: #fff;
    border: 1px solid #ddd;
  }
</style>
